package com.artvending.warden

interface Db {
	suspend fun setParameter(key: String, value: String)
	
	suspend fun getParameter(key: String, defaultValue: String = ""): String
}